// Mirrors medipro-backend/constants/lead.js.

export const LEAD_SOURCES = [
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "google", label: "Google Ads" },
  { key: "justdial", label: "JustDial" },
  { key: "practo", label: "Practo" },
  { key: "website", label: "Website" },
  { key: "whatsapp", label: "WhatsApp" },
  { key: "phone", label: "Phone call" },
  { key: "walkin", label: "Walk-in" },
  { key: "referral", label: "Referral" },
  { key: "other", label: "Other" },
];
export const SOURCE_LABEL = Object.fromEntries(LEAD_SOURCES.map((s) => [s.key, s.label]));

export const LEAD_STATUS_LABEL = {
  new: "New",
  contacted: "Contacted",
  follow_up: "Follow-up",
  booked: "Appointment booked",
  converted: "Converted",
  lost: "Lost",
  junk: "Junk",
};

export const CONVERSATION_STATES = [
  { key: "pending_approval", label: "Awaiting approval" },
  { key: "needs_human", label: "Needs human" },
  { key: "bot_active", label: "Bot handling" },
  { key: "human_active", label: "With staff" },
  { key: "closed", label: "Closed" },
];
export const STATE_LABEL = Object.fromEntries(CONVERSATION_STATES.map((s) => [s.key, s.label]));

export const OUTCOMES = [
  { key: "book_appointment", label: "Book appointment" },
  { key: "follow_up", label: "Follow up later" },
  { key: "info_only", label: "Information only" },
  { key: "not_interested", label: "Not interested" },
  { key: "junk", label: "Junk / wrong number" },
];
export const OUTCOME_LABEL = Object.fromEntries(OUTCOMES.map((o) => [o.key, o.label]));

export const LEAD_CHAT_EVENT = "lead_chat";
